import { render } from "./kumu.vue?vue&type=template&id=53cfef78&scoped=true"
import script from "./kumu.vue?vue&type=script&lang=js"
export * from "./kumu.vue?vue&type=script&lang=js"

import "./kumu.vue?vue&type=style&index=0&id=53cfef78&scoped=true&lang=css"

import exportComponent from "/home/runner/work/helixpay-website/helixpay-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53cfef78"]])

export default __exports__